import { all } from 'redux-saga/effects';
import { requestsSagas } from 'store/ConfigureStore';
import loginSaga from './LoginSaga';
import ChainedActionSaga from './ChainedActionSaga';
import ClientSelectSaga from './ClientSelectSaga';
import { autoSignOutSaga } from './AutoSignOutSaga';
import { watchProviderCommentDetail } from './providerCommentsSaga';
import { watchTrendingData } from './trendingSaga';

function* rootSaga() {
  yield all([
    ...requestsSagas,
    ...autoSignOutSaga,
    loginSaga(),
    ChainedActionSaga(),
    ClientSelectSaga(),
    watchProviderCommentDetail(),
    watchTrendingData(),
  ]);
}

export default rootSaga;